import React from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import { makeStyles } from "@material-ui/core/styles";
import { BackgroundComponent } from "../common";
import { Typography } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import Link from "@material-ui/core/Link";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import CloseIcon from "@material-ui/icons/Close";
import { useWindowDimensions } from "../common/window-dimensions";
import { history } from "../../index";
import "../common/animation.css";

const useStyles = makeStyles((theme) => ({
  canvas: {
    minHeight: "100vh",
    width: "100vw",
    marginTop: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  innercanvas: {
    marginTop: 20,
    marginBottom: 20,
    minHeight: "80vh",
    width: "60%",
    backgroundColor: "#E2C9A2",
    [theme.breakpoints.down("sm")]: {
      width: "80%",
    },
  },
  content: {
    marginTop: 10,
    marginLeft: 30,
    marginRight: 10,
    paddingBottom: 20,
  },
  listItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  list: {
    padding: 0,
    marginRight: 30,
    marginLeft: 10,
    marginTop: 8,
    [theme.breakpoints.down("xs")]: {
      marginRight: 5,
      marginLeft: 0,
    },
  },
  link: {
    color: "blue",
    textDecoration: "underline",
    wordBreak: "break-word",
  },
  details: {
    textAlign: "justify",
    cursor: "context-menu",
  },
  close: {
    right: 0,
    cursor: "pointer",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    height: 60,
  },
  mainText: {
    cursor: "context-menu",
  },
}));

export default function GlossaryMenu() {
  const classes = useStyles();
  const navigateGame = () => {
    history.push("/game");
  };

  const resources = [
    {
      id: 1,
      name: "Online Med Ed",
      details:
        "The site is extensive and includes freely accessible videos covering specialties like Trauma, Pediatrics, Nephrology, Endocrinology, and Infectious Disease and an Intern Content section with subjects such as certain diseases and conditions (renal failure, congestive heart failure), patient parameters (like electrolytes) and specific signs and symptoms (such as delirium, weakness or hemoptysis).",
      link: "https://home.onlinemeded.org/",
    },
    {
      id: 2,
      name: "The WebPath",
      details:
        "The WebPath® educational resource contains over 2700 images with text that illustrate gross and microscopic pathologic findings along with radiologic imaging associated with human disease conditions. For self-assessment and self-directed study there are over 1300 examination items. There are more than 20 tutorials in specific subject areas. These computer-aided instructional materials support educational programs in the health sciences.",
      link: "https://webpath.med.utah.edu/webpath.html#MENU",
    },
    {
      id: 3,
      name: "The Lancet",
      details:
        "The Lancet's interactive Picture Quiz Gallery hosts a new picture quiz each month. Play the picture quiz to test your medical knowledge and diagnostic skills. Each quiz is a multi-choice challenge which give you the option to play more or read about the patient's presentation and diagnosis.",
      link: "https://www.thelancet.com/picture-quiz",
    },
    {
      id: 4,
      name: "University of Michigan Family Medicine Education Modules ",
      details:
        "The University of Michigan Department of Family Medicine presents high-quality modules on a broad range of clinical topics that are free and available to the public. New modules are regularly added.",
      link: "https://sites.google.com/a/umich.edu/fammed-modules/home",
    },
    {
      id: 5,
      name: "MedEdPORTAL",
      details:
        "MedEdPORTAL is a MEDLINE-indexed, open-access journal of teaching and learning resources in the health professions published by the Association of American Medical Colleges (AAMC), in partnership with the American Dental Education Association. MedEdPORTAL publications are stand-alone, complete teaching or learning modules that have been implemented and evaluated with medical or dental trainees or practitioners. Each submission is reviewed by editorial staff and external peer reviewers using a standardized review instrument grounded in the tenets of educational scholarship.",
      link: "https://www.mededportal.org/",
    },
    {
      id: 6,
      name: "MedPix",
      details:
        "MedPix® is a free open-access online database of medical images, teaching cases, and clinical topics, integrating images and textual metadata including over 12,000 patient case scenarios, 9,000 topics, and nearly 59,000 images. Primary target audience includes physicians and nurses, allied health professionals, medical students, nursing students and others interested in medical knowledge. In addition to searching and browsing images and cases, the MedPix® website provides free AMA Category 1 CME credits online. Earn up to 30 minutes of CME with each completed case.",
      link: "https://medpix.nlm.nih.gov/home",
    },
  ];

  const { height } = useWindowDimensions();

  return (
    <React.Fragment>
      <CssBaseline />
      <BackgroundComponent transparent />
      <div className={classes.canvas}>
        <Paper className={`${classes.innercanvas} fadein`}>
          <div className={classes.content}>
            <div className={classes.header}>
              <h1 style={{ cursor: "context-menu", marginTop: 10 }}>
                Resources
              </h1>
              <CloseIcon
                className={classes.close}
                fontSize="large"
                onClick={navigateGame}
              />
            </div>
            <Typography variant="body1" className={classes.mainText}>
              Welcome to resources.
            </Typography>
            <Typography variant="body1" className={classes.mainText}>
              You can access the resources that you need by clicking the
              references below.
            </Typography>

            <List
              className={classes.list}
              style={{
                minHeight: 360,
                maxHeight: height - 230,
                overflowY: "auto",
              }}
            >
              {resources.map((item) => (
                <ListItem key={item.id} className={classes.listItem}>
                  <Link
                    variant="body1"
                    style={{ fontWeight: 550 }}
                    href={item.link}
                    color="inherit"
                    target="_blank"
                    rel="noopener"
                  >
                    {item.name}
                  </Link>
                  <Link
                    className={classes.link}
                    href={item.link}
                    color="inherit"
                    target="_blank"
                    rel="noopener"
                  >
                    {item.link}
                  </Link>
                  <Typography variant="body2" className={classes.details}>
                    {item.details}
                  </Typography>
                </ListItem>
              ))}
            </List>
          </div>
        </Paper>
      </div>
    </React.Fragment>
  );
}
